const _buildOnlyError = name => {
  throw new Error(name + " is a build-only config option and cannot be accessed at runtime");
};
import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: ['/:lang/marketplace', '/marketplace'],
  htmlTitle: 'HubSpot Marketplace',
  htmlTitleLangKey: 'marketplaceStorefront.htmlTitle',
  get additionalDlbs() {
    _buildOnlyError("additionalDlbs");
  },
  includeDefaultViewportMetaTag: true,
  theme: 'trellis-light',
  icons: {
    icon: {
      src: 'favicon.png',
      type: 'image/png'
    }
  },
  head: {
    scripts: [{
      url: 'https://www.hubspot.com/wt-assets/static-files/compliance/index.js',
      async: true,
      dataAttributes: {
        'data-external-hs-domain': 'true',
        'data-gtm-id': 'GTM-NN9PVWW'
      }
    }]
  }
});